import { render } from "./nav-header.vue?vue&type=template&id=c6f1fc8a&scoped=true&ts=true"
import script from "./nav-header.vue?vue&type=script&lang=ts"
export * from "./nav-header.vue?vue&type=script&lang=ts"

import "./nav-header.vue?vue&type=style&index=0&id=c6f1fc8a&scoped=true&lang=css"

import exportComponent from "/vercel/path2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f1fc8a"]])

export default __exports__